import { $, el } from './dom.js';

/** Transient bottom-centre notice: rate limits, "too far", reconnects. */
export function toast(text: string, kind: 'info' | 'error' = 'info'): void {
  const host = $('toasts');
  const node = el('div', { className: `toast toast-${kind}`, text });
  host.append(node);
  window.setTimeout(() => {
    node.classList.add('leaving');
    window.setTimeout(() => node.remove(), 250);
  }, 3200);
}
